import { useEffect } from "react";

/**
 * NoIndex — injects <meta name="robots" content="noindex,nofollow"> into <head>
 * while the component is mounted. Removes it on unmount. Use on admin routes
 * so search engines do not index protected pages.
 */
export default function NoIndex() {
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow, noarchive";
    meta.setAttribute("data-st-noindex", "true");
    document.head.appendChild(meta);

    const gMeta = document.createElement("meta");
    gMeta.name = "googlebot";
    gMeta.content = "noindex, nofollow";
    gMeta.setAttribute("data-st-noindex", "true");
    document.head.appendChild(gMeta);

    return () => {
      meta.remove();
      gMeta.remove();
    };
  }, []);
  return null;
}
